<template>
  <el-form
    class="
      grid grid-cols-1
      md:grid-cols-2
      lg:grid-cols-4
      gap-4
      my-3
      demo-ruleForm
      tableSearch
    "
    label-position="top"
  >
    <VehicleTag
      :value="tagValue"
      v-if="searchTag"
      @tags="$emit('selectedTags', $event)"
    />
    <slot></slot>

    <el-button
      v-if="clear"
      @click="$emit('clearFilter')"
      class="
        md:flex
        lg:col-start-3
        md:col-start-1
        clear-table-filter
        justify-center
        items-center
      "
    >
      {{ $t("FILTER_RESET") }}
    </el-button>
    <el-form-item
      v-if="searchable"
      class="lg:col-start-4 md:col-start-2"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
    >
      <el-input
        :placeholder="placeholder"
        class=""
        v-model="search"
        @input="$emit('search', search)"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import VehicleTag from "./vehcileTag.vue";

export default {
  props: {
    placeholder: String,
    clear: Boolean,
    loading: Boolean,
    searchTag: Boolean,
    tagValue: Array,
    searchValue: String,
    searchable: { type: Boolean, default: true },
  },
  data() {
    return {
      search: this.searchValue || "",
    };
  },
  components: {
    VehicleTag,
  },
  watch: {
    searchValue(newVal) {
      this.search = newVal || ""; // Update `search` when `searchValue` changes
    },
  },
};
</script>
